import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../../i18n/components/T.js'
import { Link } from '../../../Link/Link.js'

interface Props {
  isPrivateNetwork: boolean
  isPrivateSpace: boolean
  isNetworkNoIndex: boolean
}
export const NoIndexWarnings = ({
  isPrivateNetwork,
  isPrivateSpace,
  isNetworkNoIndex,
}: Props) => {
  if (isPrivateNetwork) {
    return (
      <Alert status="info">
        <T
          defaultMessage="Your site is private. As a result, its spaces will not be indexed by search engines. <link>Site settings</link>"
          id="Admin.Space.HideSeo.PrivateSiteWarning"
          values={{
            link: chunks => {
              return (
                <Link
                  href={adminRoutes.settings.network.root}
                  variant="accent"
                  target="_blank"
                  className="inline-block"
                >
                  <SvgIcon name="cog" className="ms-1" inline />
                  {chunks}
                </Link>
              )
            },
          }}
        />
      </Alert>
    )
  }

  if (isNetworkNoIndex) {
    return (
      <Alert status="info">
        <T
          defaultMessage="You have hidden your site from search engines. Therefore, its spaces will not be indexed. <link>SEO settings</link>"
          id="Admin.Space.HideSeo.HiddenSiteWarning"
          values={{
            link: chunks => {
              return (
                <Link
                  href={adminRoutes.settings.seo.root}
                  variant="accent"
                  target="_blank"
                  className="inline-block"
                >
                  <SvgIcon name="cog" className="ms-1" inline />
                  {chunks}
                </Link>
              )
            },
          }}
        />
      </Alert>
    )
  }

  if (isPrivateSpace) {
    return (
      <Alert status="info">
        <T
          defaultMessage="Your space is private. Therefore, its posts will not be indexed by search engines."
          id="Admin.Space.HideSeo.PrivateSpaceWarning"
        />
      </Alert>
    )
  }

  return null
}
